import $ from "jquery";
import "slick-carousel";
import slickCss from "slick-carousel/slick/slick.css";

const domElements = {};

function initDomElements() {
  //  domElements.main = $(".product-single-slider");
  domElements.main = $(".logo-wall__items");
  if (domElements.main.length < 1) return false;
  return true;
}

function logoWallSlider() {
  if (!initDomElements()) {
    return false;
  }
  domElements.main.slick({
    mobileFirst: true,
    dots: false,
    appendDots: $(".logo-wall__dots"),
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".logo-wall__arrow--prev"),
    nextArrow: $(".logo-wall__arrow--next"),
    rows: 0,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });
}

export default logoWallSlider;
